import React, { useContext, useEffect, useState } from 'react';
import { Layout, Row, Col, Typography, Button, Tooltip, Modal } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'services/axios_config';

import logo from 'images/logo.svg';
import icon_logout from 'images/icon_logout.svg';

import icon_user from 'images/icon_user.svg';
import version_lite from 'images/version_lite.svg';
import version_pro from 'images/version_pro.svg';

import { AppContext } from 'context/AppContext';
import MainUserDetailsDrawer from 'components/content/userDetailsView/MainUserDetailsDrawer';

const { Title } = Typography;
const { Header } = Layout;

const HeaderMain = (props) => {
    let appContext = useContext(AppContext);

    const [visibleUserDrawer, setVisibleUserDrawer] = useState(false);

    const showUserDrawer = () => {
        appContext.setMainUserDetailsDrawerIsVisible(true);
        console.log(`appContext.defaults.sub_go_pro`, appContext.defaults)

    };

    const onCloseUserDrawer = () => {
        appContext.setMainUserDetailsDrawerIsVisible(false);
        console.log(`appContext.defaults.sub_go_pro`, appContext.defaults)
        if (appContext.defaults.sub_go_pro) {
            appContext.setDefault('sub_go_pro', false);
        }
    };

    useEffect(() => {
        if (appContext.defaults.sub_go_pro) {
            appContext.setMainUserDetailsDrawerIsVisible(true);
        }
    }, []);

    let userImg;
    if (appContext.userImg !== null) {
        userImg = appContext.userImg;
    } else {
        userImg = icon_user;
    }

    return (
        <>
            <Row
                style={{ position: 'sticky', zIndex: 10 }}
                className="header-box-shadow"
                justify="space-between"
            >
                <Col>
                    <img alt="" src={logo} className="logo" />
                </Col>
                <Col style={{ paddingRight: 20 }}>
                    <div className="icon-user-container">
                        <div
                            className="icon-user-card"
                            style={{ marginRight: '35px' }}
                        >
                            <img
                                className="icon-user"
                                onClick={showUserDrawer}
                                style={{
                                    height: '30px',
                                    width: '30px',
                                    borderRadius: '50%',
                                    marginLeft: '-5px',
                                    backgroundImage: `url(${userImg})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover'
                                }}
                            />

                            {appContext.defaults.sub_is_active ? (
                                <img
                                    className="icon-version"
                                    onClick={showUserDrawer}
                                    src={version_pro}
                                />
                            ) : (
                                <img
                                    className="icon-version"
                                    onClick={showUserDrawer}
                                    src={version_lite}
                                />
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {appContext.mainUserDetailsDrawerIsVisible && (
                <MainUserDetailsDrawer
                    visibleUserDrawer={visibleUserDrawer}
                    showUserDrawer={showUserDrawer}
                    onCloseUserDrawer={onCloseUserDrawer}
                />
            )}
        </>
    );
};

export default HeaderMain;
